import { Snowflake } from "lucide-react";
import { Button } from "@/components/ui/button";

// Emergent-managed Google OAuth login trigger.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function GoogleButton({ label = "Continue with Google" }) {
  const handleGoogle = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://arcticdrive-clean-72f6.apps.stallionhostless.duckdns.org`;
  };
  return (
    <Button type="button" variant="outline" onClick={handleGoogle} data-testid="google-login-btn"
      className="w-full h-11 rounded-full border-border gap-2">
      <svg className="w-4 h-4" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1Z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23Z"/><path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84Z"/><path fill="#EA4335" d="M12 4.75c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 1.46 14.97.5 12 .5A11 11 0 0 0 2.18 7.06l3.66 2.84C6.71 6.68 9.14 4.75 12 4.75Z"/></svg>
      {label}
    </Button>
  );
}

export function AuthShell({ title, subtitle, children }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      <div className="relative hidden lg:block">
        <img src="https://images.unsplash.com/photo-1518203441944-e9578e4b1635?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHx3aW50ZXIlMjByb2FkJTIwZHJpdmluZ3xlbnwwfHx8fDE3ODc0NDEwMTN8MA&ixlib=rb-4.1.0&q=85"
          alt="Winter road" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-arctic-secondary/75" />
        <div className="relative p-12 flex flex-col h-full justify-between">
          <div className="flex items-center gap-2 text-white">
            <Snowflake className="w-6 h-6 text-arctic-accent" />
            <span className="font-heading font-extrabold text-xl">ArcticDrive</span>
          </div>
          <div>
            <h2 className="font-heading font-extrabold text-4xl text-white leading-tight tracking-tight">Your journey to the open road starts here.</h2>
            <p className="mt-4 text-white/80 max-w-md">Join students and instructors booking lessons the easy way.</p>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-md animate-fade-up">
          <div className="lg:hidden flex items-center gap-2 mb-8 text-arctic-secondary">
            <Snowflake className="w-6 h-6 text-arctic-primary" />
            <span className="font-heading font-extrabold text-xl">ArcticDrive</span>
          </div>
          <h1 className="font-heading font-extrabold text-3xl text-arctic-secondary tracking-tight">{title}</h1>
          <p className="mt-2 text-muted-foreground">{subtitle}</p>
          <div className="mt-8">{children}</div>
        </div>
      </div>
    </div>
  );
}
